import gql from "graphql-tag";

const LIST = gql`
	query GetStatsForManagement {
		CountWard {
			ward
			room
			bed
		}
		PatientSiteCount {
			parentSite
			site
		}
		TotalSuperAdmin
		AmountEaredByCurrency {
			currency
			amount
		}
		TotalActiveSubscription
		TotalExpiredSubscription
	}
`;

export { LIST };
